import {
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    FormHelperText,
    TextField,
    Checkbox, IconButton,
    ListItemText, InputAdornment
} from "@mui/material";
import OutlinedInput from "@mui/material/OutlinedInput";
import { useState } from "react";
import ClearIcon from "@mui/icons-material/Clear";


const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 280,
        },
    },
};

export default function MultiSelectWithAll({
    name,
    label,
    options = [],           // always an array
    value = [],             // always an array of objects
    onChange,
    error = false,          // always boolean
    formHelperText = "",    // always string
    disabled = false,       // always boolean
}) {
    const allValues = options; // full objects

    const handleChange = (e) => {
        const { value: newValue } = e.target;

        let updatedValues = [];

        if (newValue.includes("ALL")) {
            if (value.length === allValues.length) {
                // 🔹 Unselect all
                updatedValues = [];
            } else {
                // 🔹 Select all (store objects)
                updatedValues = allValues;
            }
        } else {
            // 🔹 Map selected IDs back to objects
            updatedValues = options.filter((opt) =>
                newValue.includes(opt.value)
            );
        }

        if (onChange) {
            onChange(name, updatedValues);
        }
    };

    const [search, setSearch] = useState("");

    // const filteredOptions = options?.filter((opt) =>
    //     opt.label.toLowerCase().includes(search.toLowerCase())
    // );

    // const isAllSelected = value.length === options.length && options.length > 0;
    const isAllSelected = value.length === options.length;

    return (
        <FormControl fullWidth size="small" error={Boolean(error)}>
            <InputLabel id={`${name}-label`}>{label}</InputLabel>
            <Select
                labelId={`${name}-label`}
                id={`${name}-select`}
                label={label}
                multiple
                MenuProps={{
                    autoFocus: false,  // ✅ prevents dropdown from auto-scrolling
                    PaperProps: {
                        sx: {
                            maxHeight: 240,
                            minWidth: 160,
                            padding: 0,
                        }
                    },
                    MenuListProps: {
                        sx: {
                            py: 0
                        }
                    }
                }}
                disabled={disabled}
                // ensure always array of strings
                value={Array.isArray(value) ? value.map((opt) => opt.value) : []}
                onChange={handleChange}
                renderValue={(selectedVals) => {
                    if (selectedVals.length === options.length) {
                        return "Select All";
                    }
                    return options
                        .filter((opt) => selectedVals.includes(opt.value))
                        .map((opt) => opt.label)
                        .join(", ");
                }}
            >

                {/* 🔍 Search */}
                {/* <MenuItem disableRipple disableTouchRipple>
                    <TextField
                        size="small"
                        autoFocus
                        placeholder="Search..."
                        fullWidth
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        onKeyDown={(e) => e.stopPropagation()}
                        InputProps={{
                            endAdornment: search && (
                                <InputAdornment position="end">
                                    <IconButton
                                        size="small"
                                        onClick={() => setSearch("")}
                                        edge="end"
                                    >
                                        <ClearIcon fontSize="small" />
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }}
                    />
                </MenuItem> */}

                {/* <MenuItem value="ALL">
                    <Checkbox
                        checked={isAllSelected}
                        indeterminate={value.length > 0 && !isAllSelected}
                    />
                    <ListItemText primary="Select All" />
                </MenuItem> */}


                <MenuItem value="ALL">
                    <Checkbox checked={isAllSelected} />
                    <ListItemText
                        primary={isAllSelected ? "Unselect All" : "Select All"}
                    />
                </MenuItem>
                
                {options.map((opt) => (
                    <MenuItem key={opt.value} value={opt.value} >
                        <Checkbox
                            checked={value.some((v) => v.value === opt.value)}
                        />
                        {/* <ListItemText primary={opt.label} /> */}
                        <ListItemText
                            primary={opt.label}
                            primaryTypographyProps={{
                                sx: {
                                    display: "-webkit-box",
                                    WebkitLineClamp: 2,          // ✅ 2 lines only
                                    WebkitBoxOrient: "vertical",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "normal",
                                    lineHeight: 1.4,
                                    wordBreak: "break-word",
                                }
                            }}
                        />

                    </MenuItem>
                ))}
            </Select>
            {error && formHelperText && (
                <FormHelperText>{formHelperText}</FormHelperText>
            )}
        </FormControl>
    );
}

